/* global axios */
/* eslint-disable class-methods-use-this */

import JwtAuth from './jwtAuth';

const baseUrl =
  process.env.FRONTEND_ENV === 'develop'
    ? 'https://staging.chatlyn.com'
    : window.location.origin;
const url = baseUrl + '/inboxmw/whatsapp/onboarding';

class WhatsAppOnboarding {
  getWAOnboardingStatus = async ({ accountId, phoneNumber }) => {
    const jwtAuthTokens = await JwtAuth.getUserTokens();
    return axios.get(`${url}/status/${phoneNumber}?accountId=${accountId}`, {
      headers: {
        Authorization: `Bearer ${jwtAuthTokens.access_token}`,
      },
    });
  };

  // Note: This endpoint has @SkipIdempotency() on the backend, so no Idempotency-Key header is required
  startWAOnboarding = async ({ accountId, phoneNumber }) => {
    const jwtAuthTokens = await JwtAuth.getUserTokens();
    return axios.post(
      `${url}/phone/${accountId}`,
      { phoneNumber },
      {
        headers: {
          Authorization: `Bearer ${jwtAuthTokens.access_token}`,
        },
      }
    );
  };
}

export default new WhatsAppOnboarding();
